import axios from "axios";
import { takeLatest, call, put, select, takeEvery, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const SET_LOADING = "saga/attendance/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/attendance/SET_PREV_PAGE_FILTERS";

export const FETCH_CURRENT_USER = "saga/attendance/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/attendance/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/attendance/FETCH_CURRENT_USER_FAILURE";

export const UPDATE_ALL_DATA = "saga/attendance/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/attendance/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/attendance/UPDATE_ALL_DATA_FAILURE";

export const FETCH_TOP_PERFORMERS_SUCCESS = "saga/attendance/FETCH_TOP_PERFORMERS_SUCCESS";
export const FETCH_TOP_PERFORMERS_FAILURE = "saga/attendance/FETCH_TOP_PERFORMERS_FAILURE";
export const FETCH_POOR_PERFORMERS_SUCCESS = "saga/attendance/FETCH_POOR_PERFORMERS_SUCCESS";
export const FETCH_POOR_PERFORMERS_FAILURE = "saga/attendance/FETCH_POOR_PERFORMERS_FAILURE";

export const FETCH_CLASS_BY_TYPE_SUCCESS = "saga/attendance/FETCH_CLASS_BY_TYPE_SUCCESS";
export const FETCH_CLASS_BY_TYPE_FAILURE = "saga/attendance/FETCH_CLASS_BY_TYPE_FAILURE";

export const FETCH_ACTIVE_CLIENTS_SUCCESS = "saga/attendance/FETCH_ACTIVE_CLIENTS_SUCCESS";
export const FETCH_ACTIVE_CLIENTS_FAILURE = "saga/attendance/FETCH_ACTIVE_CLIENTS_FAILURE";

export const REMOVE_CLASS_CATEGORY = "saga/attendance/REMOVE_CLASS_CATEGORY";
export const REMOVE_CLASS_CATEGORY_FAILURE = "saga/attendance/REMOVE_CLASS_CATEGORY_FAILURE";
export const REMOVE_CLASS_CATEGORY_SUCCESS = "saga/attendance/REMOVE_CLASS_CATEGORY_SUCCESS";

export const ADD_CLASS_CHART = "saga/attendance/ADD_CLASS_CHART";
export const ADD_CLASS_CHART_SUCCESS = "saga/attendance/ADD_CLASS_CHART_SUCCESS";
export const ADD_CLASS_CHART_FAILURE = "saga/attendance/ADD_CLASS_CHART_FAILURE";

export const SET_CLASS_TYPES_CHECKED = "saga/attendance/SET_CLASS_TYPES_CHECKED";
export const SET_CLASS_TYPES_CHECKED_SUCCESS = "saga/attendance/SET_CLASS_TYPES_CHECKED_SUCCESS";
export const SET_CLASS_TYPES_CHECKED_FAILURE = "saga/attendance/SET_CLASS_TYPES_CHECKED_FAILURE";

export const FETCH_ALL_CLASSES_BY_TYPE = "saga/attendance/FETCH_ALL_CLASSES_BY_TYPE";
export const FETCH_ALL_CLASSES_BY_TYPE_SUCCESS =
  "saga/attendance/FETCH_ALL_CLASSES_BY_TYPE_SUCCESS";
export const FETCH_ALL_CLASSES_BY_TYPE_FAILURE =
  "saga/attendance/FETCH_ALL_CLASSES_BY_TYPE_FAILURE";

let date;

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  removeClassCategory: createAction(REMOVE_CLASS_CATEGORY),
  addClassChart: createAction(ADD_CLASS_CHART),
  setClassTypesChecked: createAction(SET_CLASS_TYPES_CHECKED)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
  yield takeEvery(REMOVE_CLASS_CATEGORY, removeClassCategory);
  yield takeLatest(ADD_CLASS_CHART, addClassChart);
}

export function* getCurrentUserData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  date = payload.date;

  let { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  let params = { organization_id, short_url, date };
  let allSagas = [
    getTopPerformers(params),
    getPoorPerformers(params),
    getClassByTypeData(params),
    getActiveClientsData(params),
    getAllClassesByTypeData(params)
  ];

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  date = payload.date;

  let { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  let params = { organization_id, short_url, date };

  let allSagas = [
    getTopPerformers(params),
    getPoorPerformers(params),
    getClassByTypeData(params),
    getActiveClientsData(params),
    getAllClassesByTypeData(params)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getTopPerformers(params) {
  try {
    const topPerformersResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/attendance/top_performers",
      { params }
    );
    yield put({ type: FETCH_TOP_PERFORMERS_SUCCESS, payload: topPerformersResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_TOP_PERFORMERS_FAILURE, error });
  }
}

export function* getPoorPerformers(params) {
  try {
    const poorPerformersResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/attendance/poor_performers",
      { params }
    );
    yield put({ type: FETCH_POOR_PERFORMERS_SUCCESS, payload: poorPerformersResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_POOR_PERFORMERS_FAILURE, error });
  }
}

export function* getClassByTypeData(params) {
  try {
    const revenueByTypeResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/attendance/class_by_types",
      { params }
    );
    yield put({ type: FETCH_CLASS_BY_TYPE_SUCCESS, payload: revenueByTypeResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_CLASS_BY_TYPE_FAILURE, error });
  }
}

export function* getAllClassesByTypeData(params) {
  try {
    const getClassByTypeResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/attendance/class_by_types/all_classes_by_type",
      { params }
    );
    yield put({ type: FETCH_ALL_CLASSES_BY_TYPE_SUCCESS, payload: getClassByTypeResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_ALL_CLASSES_BY_TYPE_FAILURE, error });
  }
}

export function* getActiveClientsData(params) {
  try {
    const activeClientsResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/attendance/active_clients",
      { params }
    );
    yield put({ type: FETCH_ACTIVE_CLIENTS_SUCCESS, payload: activeClientsResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_ACTIVE_CLIENTS_FAILURE, error });
  }
}

export function* removeClassCategory() {
  let charts = yield select((state) => state.attendance.classByTypeAttendance);
  let { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  let chartsToPush = [];
  charts.map((items) => {
    chartsToPush.push(items.id);
  });

  let params = {
    organization_id,
    short_url,
    default_class_type_ids: chartsToPush.length ? chartsToPush : [""],
    date
  };

  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion + "pages/my_dashboard/attendance/class_by_types/set_default_class_type_ids",
      params
    );
    yield put({ type: REMOVE_CLASS_CATEGORY_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: REMOVE_CLASS_CATEGORY_FAILURE, error });
  }
}

export function* setClassTypesChecked(action) {
  try {
    yield put({ type: SET_CLASS_TYPES_CHECKED_SUCCESS, payload: action.payload });
  } catch (error) {
    console.error(error);
    yield put({ type: SET_CLASS_TYPES_CHECKED_FAILURE, error });
  }
}

export function* addClassChart() {
  let chartId = yield select((state) => state.attendance.classByTypeAttendanceChecked);
  let { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  let params = {
    organization_id,
    short_url,
    default_class_type_ids: chartId.length ? chartId : [""],
    date
  };

  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion + "pages/my_dashboard/attendance/class_by_types/set_default_class_type_ids",
      params
    );
    yield put({ type: ADD_CLASS_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: ADD_CLASS_CHART_FAILURE, error });
  }
}
